import { render, staticRenderFns } from "./Carrier.vue?vue&type=template&id=0138eee5&lang=pug"
import script from "./Carrier.vue?vue&type=script&lang=js"
export * from "./Carrier.vue?vue&type=script&lang=js"
import style0 from "./Carrier.vue?vue&type=style&index=0&id=0138eee5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports